import BehaviorConfig from '@/models/app-config/behavior/behavior'
import Stock from '@/models/item/stock'
import DisplayRule, { ruleIsOnFew } from '@/models/item/stock/specification/display-rule'
import DisplayRuleSet from '@/models/item/stock/specification/display-rule/display-rule-set'
import DisplayNothing from '@/models/item/stock/specification/display-rule/each-case/display-nothing'
import NoDisplayAboutStock from '@/models/item/stock/specification/display-rule/each-case/display-nothing-about-stock'
import SoldOut from '@/models/item/stock/specification/display-rule/each-case/soldout'
import { HotelLoversPolicy, MyColorDefaultPolicy, Policy } from './get-stock-status/policy'

export default class GetStockStatus {
  static createViaConfig(
    behaviorConfig: BehaviorConfig
  ): GetStockStatus {

    return this.getPolicy(behaviorConfig).create()
  }

  private static getPolicy(behaviorConfig: BehaviorConfig): Policy {
    if (behaviorConfig.isLikeHotellovers) return HotelLoversPolicy.createViaConfig(behaviorConfig)

    return MyColorDefaultPolicy.createViaConfig(behaviorConfig)
  }

  constructor(private readonly displayRuleSet: DisplayRuleSet) { }

  toText(stock: Stock): string {
    return this.findApplicativeRule(stock).apply(stock)
  }

  isFew(stock: Stock): boolean {
    const rule = this.findApplicativeRule(stock)

    return ruleIsOnFew(rule)
  }
  isSoldOut(stock: Stock): boolean {
    const rule = this.findApplicativeRule(stock)

    return rule instanceof SoldOut
  }
  isNormal(stock: Stock): boolean {
    const rule = this.findApplicativeRule(stock)

    return rule instanceof DisplayNothing
      || rule instanceof NoDisplayAboutStock
  }
  exists(stock: Stock): boolean {
    return !this.isSoldOut(stock)
  }

  /**
   * 2023/12までは煽り在庫 (display stock) を採用することがあったが、常にWEB在庫を採用するように修正された。
   * 今後煽り在庫の在庫数を取得したいケースが発生する場合は適宜メソッドを整理して実装すること。
   * @see https://github.com/my-color/growthpalette-front/issues/7789
   */
  amount(stock: Stock): number {
    return stock.web.amount
  }

  private findApplicativeRule(stock: Stock): DisplayRule {
    return this.displayRuleSet.find(stock)
  }
}
